import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { adminAuth } from "../../services/adminApi";

export default function AdminProtected({ children }) {
  const [state, setState] = useState("checking"); // checking | ok | unauth

  useEffect(() => {
    if (!adminAuth.isAuthenticated()) {
      setState("unauth");
      return;
    }
    adminAuth
      .me()
      .then(() => setState("ok"))
      .catch(() => setState("unauth"));
  }, []);

  if (state === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50">
        <div className="text-stone-400 text-sm">Cargando...</div>
      </div>
    );
  }

  if (state === "unauth") {
    return <Navigate to="/admin" replace />;
  }

  return children;
}
